export default __webpack_public_path__ + "static/media/security-guard.3b6d9c04.svg";